
const newModel = () => {
    return {
        truongchuanQuocgiaId: null,
        tenTruong: null,
        truongId: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        tenMucTruongchuan: null,
        namCongNhan: null,
        phanloaiTruongchuanId: null,
        tenPhanloaiTruongchuan: null,
        phuongXaId: null,
        tenPhuongXa: null,
        quymoTruongchuanId: null,
        tenQuymoTruongchuan: null,
        // capHocId: null,
        // tenCapHoc: null,
        namSatNhap: null,
        congLap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,
        soluongLop: 0,
        soluongGiaovien: 0,
        soluongHocsinh: 0,
        soluongHocsinhNhapsodinhdanh: 0,
        ghiChu: null,
        gioiThieu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        truongchuanQuocgiaId: null,
        tenTruong: null,
        truongId: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        namCongNhan: null,
        phanloaiTruongchuanId: null,
        phuongXaId: null,
        quymoTruongchuanId: null,
        // capHocId: null,
        namSatNhap: null,
        congLap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,
        soluongLop: 0,
        soluongGiaovien: 0,
        soluongHocsinh: 0,
        soluongHocsinhNhapsodinhdanh: 0,
        ghiChu: null,
        gioiThieu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

const fromJson = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        hieuTruong: item.hieuTruong,
        sdtHieuTruong: item.sdtHieuTruong,
        mucTruongchuanId: item.mucTruongchuanId,
        namCongNhan: item.namCongNhan,
        phanloaiTruongchuanId: item.phanloaiTruongchuanId,
        tenPhanloaiTruongchuan: item.tenPhanloaiTruongchuan,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        quymoTruongchuanId: item.quymoTruongchuanId,
        // capHocId: item.capHocId,
        namSatNhap: item.namSatNhap,
        congLap: item.congLap,
        vemisId: item.vemisId,
        namThanhLap: item.namThanhLap,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        soluongLop: item.soluongLop,
        soluongGiaovien: item.soluongGiaovien,
        soluongHocsinh: item.soluongHocsinh,
        soluongHocsinhNhapsodinhdanh: item.soluongHocsinhNhapsodinhdanh,
        ghiChu: item.ghiChu,
        gioiThieu: item.gioiThieu,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongchuanQuocgiaId: item.truongchuanQuocgiaId,
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        hieuTruong: item.hieuTruong,
        sdtHieuTruong: item.sdtHieuTruong,
        mucTruongchuanId: item.mucTruongchuanId,
        namCongNhan: item.namCongNhan,
        phanloaiTruongchuanId: item.phanloaiTruongchuanId,
        phuongXaId: item.phuongXaId,
        quymoTruongchuanId: item.quymoTruongchuanId,
        // capHocId: item.capHocId,
        namSatNhap: item.namSatNhap,
        congLap: item.congLap,
        vemisId: item.vemisId,
        namThanhLap: item.namThanhLap,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        soluongLop: item.soluongLop,
        soluongGiaovien: item.soluongGiaovien,
        soluongHocsinh: item.soluongHocsinh,
        soluongHocsinhNhapsodinhdanh: item.soluongHocsinhNhapsodinhdanh,
        ghiChu: item.ghiChu,
        gioiThieu: item.gioiThieu,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        tenTruong: null,
        truongId: null,
        vemisId: null,
        mucTruongchuanId: null,
        quymoTruongchuanId: null,
        phanloaiTruongchuanId: null,
        congLap: null,
        // capHocId: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        vemisId: item.vemisId,
        mucTruongchuanId: item.mucTruongchuanId,
        quymoTruongchuanId: item.quymoTruongchuanId,
        phanloaiTruongchuanId: item.phanloaiTruongchuanId,
        congLap: item.congLap,
        // capHocId: item.capHocId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongchuanQuocgiaId: null,
        tenTruong: null,
        truongId: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        namCongNhan: null,
        phanloaiTruongchuanId: null,
        phuongXaId: null,
        quymoTruongchuanId: null,
        // capHocId: null,
        namSatNhap: null,
        congLap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,
        soluongLop: null,
        soluongGiaovien: null,
        soluongHocsinh: null,
        soluongHocsinhNhapsodinhdanh: null,
        ghiChu: null,
        gioiThieu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

export const truongQGGDModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


